var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "col-md-12 no-padding no-margin row" },
        [
          _c("div", { staticClass: "col-12 mt-3 mb-3" }, [
            _c("h4", {
              staticClass: "text-center",
              domProps: { innerHTML: _vm._s(_vm.title) }
            })
          ]),
          _vm._v(" "),
          _vm._l(_vm.mapApps, function(app, index) {
            return _c(
              "div",
              { key: index, staticClass: "col-md-12 col-lg-6" },
              [
                _c("div", { staticClass: "col-md-12 card" }, [
                  _c("div", { staticClass: "top" }, [
                    _c(
                      "div",
                      {
                        staticClass: "icon",
                        style:
                          "background:" + _vm.$t(app.translate + ".bgcolor")
                      },
                      [_c("i", { class: _vm.$t(app.translate + ".icon") })]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "details" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.$t(app.translate + ".fullname")))
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t(app.translate + ".description")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "footer row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        [
                          app.app_id == 7 || app.app_id == 9 || app.app_id == 10
                            ? _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      top: "18px",
                                      color: "#D4D4D4"
                                    }
                                  },
                                  [_vm._v("(Coming Soon)")]
                                )
                              ])
                            : _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-between align-items-center h-100"
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "#D4D4D4" } },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(app.moduleStatusText) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-right" }, [
                                    _c(
                                      "button",
                                      {
                                        class: ["btn", app.buttonColor],
                                        attrs: {
                                          "data-v-step": "appid" + app.app_id
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClickInstallApp(
                                              app
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(app.buttonText) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                        ]
                      ],
                      2
                    )
                  ])
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(_vm.recommendInstallApps, function(app, index) {
        return _c("v-tour", {
          key: index,
          class: "install-apps appid" + app.appid,
          attrs: {
            name: "appid" + app.appid,
            steps: app.steps,
            options: _vm.tourOptions
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23e404ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23e404ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseInstallApps.vue
// module id = null
// module chunks = 